import AttachedFileLink from './AttachedFileLink';

export default AttachedFileLink;
